<template>
    <div>
        <ConfirmationDialog v-bind="confirmationDialogParameters"
                            v-on:delete-package="deletePackage"
                            v-on:delete-pick-up-receipt="deletePickUpReceipt"/>

        <RecordDialog v-if="showRecordDialog" v-bind="recordDialogParameters"
                      v-on:hidden="showRecordDialog = false"
                      v-on:ok="setData"/>

        <!-- DOCUMENT HEADER -->

        <div class="card st-framework-card" v-if="pageLoaded">

            <div class="card-header">
                <table style="border-collapse: collapse; width: 100%;">
                    <tbody>
                    <tr>
                        <td style="margin: 0; padding: 0 0 0 1rem; width: 280px; border: solid 1px lightgray;">
                            <font-awesome-icon :icon="icon" size="sm" class="mr-2"/>
                            <template v-for="(action,index) in actions.document">
                                <SelectAction :key="action.name + '-' + index"
                                              :action="action" :disabled="state.disabled"
                                              v-on:select-view="selectView"
                                              v-if="action.type === 'SELECT' && action.placement === 'DOCUMENTHEADERLEFT'"/>
                            </template>
                        </td>
                        <td style="width: 1rem;"></td>
                        <td style="margin: 0; padding: 0 10px; border: solid 1px lightgray;">
                            <SelectField :field="fields.selectField" v-on:input="documentSelectInput"/>
                        </td>
                        <td style="margin: 0; padding: 0; width: 90px; text-align: right;">(#{{ data.id }})</td>
                        <td style="width: 1rem;"></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-body p-0">
                <div class="row no-gutters">
                    <div class="col-4">
                        <DocumentCard :title="$i18n.tc('translations.Order', 1)+' ('+data.status_text+')'"
                                      :data="data" :actions="actions.documentCard"
                                      v-on:download-packing-slip="downloadPackingSlip"/>
                    </div>
                    <div class="col-4">
                        <ProjectCard :title="$i18n.tc('translations.Project', 1)+' ('+data.project_id.status_text+')'" :readonly="data.locked"
                                     :data="data.project_id" :actions="actions.projectCard"/>
                    </div>
                    <div class="col-4">
                        <CustomerCard :title="$i18n.tc('translations.Customer', 1)" :readonly="data.locked"
                                      :data="data.project_id.customer_id"/>
                    </div>
                </div>

                <!-- PICK UP RECEIPTS TABLE-->

                <Table :key="'pick-up-receipts-table-'+reloadTableComponent" footer-class="light"
                       :title="$i18n.tc('translations.Pick Up Receipt', 2)" :state="state"
                       :highlight-row-id=selectedPickUpReceiptId highlight-rows-on-click
                       :actions="actions.table"
                       :fields="fields.table" :rows="data.pick_up_receipts"
                       :reload-table-data="reloadTableData"
                       v-on:add-row="addPickUpReceipt"
                       v-on:delete-row="confirmDeletePickUpReceipt"
                       v-on:highlight-row="highlightRow"
                       v-on:download="downloadPickUpReceipt"
                       v-on:update-row="updatePickUpReceipt"/>
                <template v-if="selectedPickUpReceipt()">
                    <div class="card">

                        <!-- PACKAGES HEADER -->

                        <div class="card-header">
                            <table style="border-collapse: collapse; width: 100%;">
                                <tbody>
                                <tr>
                                    <td>
                                        {{ selectedPickUpReceipt()['name'] }}
                                    </td>
                                    <td>
                                        <div class="float-right">
                                            <div class="input-group input-group-sm">
                                                <template v-for="(action,index) in actions.document">
                                                    <ButtonAction :key="action.name + '-' + index" :disabled="state.disabled" :action="action"
                                                                  v-on:add-package="addPackage"
                                                                  v-if="action.placement === 'GROUPHEADERRIGHT' && action.type === 'BUTTON'"/>
                                                </template>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- PACKAGES -->

                        <div class="card-body" style="padding: 1rem; padding-right: 0; padding-bottom: 0;">
                            <template v-for="(p,index) in selectedPackages()">
                                <div :key="'package-' + index" class="row no-gutters" v-if="index % 3 === 0">
                                    <template v-for="n in 3">
                                        <div :key="'package-' + index + '-' + n" class="col-4" v-if="selectedPackages()[index + n - 1]">
                                            <div class="card" style="margin: 1rem; margin-left: 0; margin-top: 0;">
                                                <div class="card-header light">
                                                    <b-form inline>
                                                        {{ $i18n.tc('translations.Package') + ': ' + selectedPackages()[index + n - 1].name }}
                                                        <template v-for="action in actions.document">
                                                            <ButtonAction :key="action.name + '-' + index + '-' + n" :disabled="state.disabled" :action="action"
                                                                          v-on:delete-package="confirmDeletePackage(index + n - 1)"
                                                                          v-if="action.placement === 'ELEMENTHEADER' && action.type === 'BUTTON' && action.name === 'delete-package'"/>
                                                            <ButtonAction :key="action.name + '-' + index + '-' + n" :disabled="state.disabled" :action="action"
                                                                          v-on:update-package="updatePackage(index + n - 1)"
                                                                          v-if="action.placement === 'ELEMENTHEADER' && action.type === 'BUTTON' && action.name === 'update-package'"/>
                                                        </template>
                                                    </b-form>
                                                </div>
                                                <div class="card-body">
                                                    <p v-html="selectedPackages()[index + n - 1].content"/>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>

                        <!-- PACKAGES FOOTER -->

                        <div class="card-footer light">
                            <table style="border-collapse: collapse; width: 100%;">
                                <tbody>
                                <tr>
                                    <td/>
                                    <td>
                                        <div class="float-right">
                                            <div class="input-group input-group-sm">
                                                <template v-for="(action,index) in actions.document">
                                                    <DropDownAction :key="action.name + '-' + index" :action="action" :disabled="state.disabled"
                                                                    v-on:download-pick-up-receipt="downloadPickUpReceipt"
                                                                    v-if="action.placement === 'GROUPFOOTERRIGHT' && action.type === 'DROPDOWN'"/>
                                                </template>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonAction from "@/components/actions/ButtonAction";
import ConfirmationDialog from "@/components/dialogs/ConfirmationDialog";
import CustomerCard from "@/components/CustomerCard.vue";
import DocumentCard from "@/components/DocumentCard.vue";
import DropDownAction from "@/components/actions/DropDownAction";
import FileDownload from "@/mixins/FileDownload";
import ProjectCard from "@/components/ProjectCard.vue";
import RecordDialog from "@/components/dialogs/RecordDialog";
import SelectField from "@/components/forms/fields/SelectField";
import SelectAction from "@/components/actions/SelectAction";
import Table from "@/components/Table.vue";
import moment from "moment/moment";

export default {
    name: "PickUpReceipt",
    components: {
        ButtonAction,
        ConfirmationDialog,
        CustomerCard,
        DocumentCard,
        DropDownAction,
        ProjectCard,
        RecordDialog,
        SelectAction,
        SelectField,
        Table,
    },
    props: ['icon', 'api', 'state', 'userName', 'userLanguage', 'languages'],
    mixins: [FileDownload],
    data() {
        return {
            pageLoaded: false,
            reloadTableComponent: 0,
            reloadTableData: 0,
            data: null,
            packages: null,
            actions: null,
            fields: null,
            selectedPickUpReceiptId: null,
            confirmationDialogParameters: {
                type: '',
                title: '',
                message: '',
                ok_event: 'ok',
                ok_text: 'OK',
                cancel_event: 'cancel',
                cancel_text: this.$i18n.t("translations.Cancel"),
                data: null,
            },
            showRecordDialog: false,
            recordDialogParameters: {
                type: null,
                title: null,
                api: null,
                fields: null,
                data: null,
                languages: this.languages,
                userLanguage: this.userLanguage,
            },
        }
    },
    watch: {
        $route() {
            this.fetchData(parseInt(this.$route.params.id));
        }
    },
    created() {
        this.fetchData(parseInt(this.$route.params.id));
    },
    methods: {
        addPackage(data) {
            this.state.loading = true;

            if (!this.selectedPickUpReceipt().packages) {
                this.selectedPickUpReceipt().packages = [];
            }
            for (let i = 0; i < data.quantity; i++) {
                this.selectedPickUpReceipt().packages.push({
                    id: this.getUniqueId(this.selectedPickUpReceipt().packages),
                    name: this.getNextName(),
                    content: null
                });
            }

            this.selectedPickUpReceipt().updated_at = moment().format("YYYY-MM-DD hh:mm:ss");
            this.selectedPickUpReceipt().updated_by = this.userName;
            this.updatePickUpReceipts();
        },
        addPickUpReceipt(data) {
            this.state.loading = true;
            this.selectedPickUpReceiptId = this.getUniqueId(this.data.pick_up_receipts);
            this.data.pick_up_receipts.push({
                id: this.selectedPickUpReceiptId,
                updated_at: moment().format("YYYY-MM-DD hh:mm:ss"),
                updated_by: this.userName,
                name: data.name,
                packages: [],
            });
            this.updatePickUpReceipts();
        },
        confirmDeletePackage(packageIdx) {
            this.confirmationDialogParameters.type = 'delete';
            this.confirmationDialogParameters.title = this.$i18n.t("translations.Delete Package") + ': ' + this.selectedPackages()[packageIdx].name;
            this.confirmationDialogParameters.message = this.$i18n.t("translations.Are you sure you want to delete this package?");
            this.confirmationDialogParameters.ok_event = 'delete-package';
            this.confirmationDialogParameters.ok_text = this.$i18n.t("translations.Delete");
            this.confirmationDialogParameters.cancel_text = this.$i18n.t("translations.Cancel");
            this.confirmationDialogParameters.data = this.selectedPackages()[packageIdx];
            this.$bvModal.show('confirmation-dialog');
        },
        confirmDeletePickUpReceipt(receipt) {
            this.confirmationDialogParameters.type = 'delete';
            this.confirmationDialogParameters.title = this.$i18n.t("translations.Delete Pick Up Receipt") + ': ' + receipt.name;
            this.confirmationDialogParameters.message = this.$i18n.t("translations.Are you sure you want to delete this pick up receipt?");
            this.confirmationDialogParameters.ok_event = 'delete-pick-up-receipt';
            this.confirmationDialogParameters.ok_text = this.$i18n.t("translations.Delete");
            this.confirmationDialogParameters.cancel_text = this.$i18n.t("translations.Cancel");
            this.confirmationDialogParameters.data = receipt;
            this.$bvModal.show('confirmation-dialog');
        },
        deletePackage(pkg) {
            this.state.loading = true;
            let packageIdx = this.selectedPackages().findIndex(p => p.id === pkg.id);
            this.selectedPackages().splice(packageIdx, 1);

            this.selectedPickUpReceipt().updated_at = moment().format("YYYY-MM-DD hh:mm:ss");
            this.selectedPickUpReceipt().updated_by = this.userName;
            this.updatePickUpReceipts();
        },
        deletePickUpReceipt(receipt) {
            this.state.loading = true;
            if (this.selectedPickUpReceiptId === receipt.id) {
                this.selectedPickUpReceiptId = null;
            }
            let receiptIdx = this.data.pick_up_receipts.findIndex(r => r.id === receipt.id);
            this.data.pick_up_receipts.splice(receiptIdx, 1);
            this.updatePickUpReceipts();
        },
        documentSelectInput(data) {
            if (data['id'] !== parseInt(this.$route.params.id)) {
                this.$router.push({params: {id: data['id']}});
            }
        },
        downloadPackingSlip(choice) {
            this.state.loading = true;
            this.$http.post(choice.api + '/' + this.data.id, null, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(choice, res.data);
                this.state.loading = false;
            }).catch((error) => {
                console.log("PickUpReceipt:downloadPackingSlip():error:", error);
            });
        },
        downloadPickUpReceipt(choice) {
            this.state.loading = true;
            this.$http.post(choice.api + '/' + this.selectedPickUpReceiptIdx() + '/' + this.data.id, null, {'responseType': 'blob'}).then((res) => {
                this.fileDownload(choice, res.data);
                this.state.loading = false;
            }).catch((error) => {
                console.log("PickUpReceipt:downloadPickUpReceipt():error:", error);
            });
        },
        fetchData(id) {
            this.state.loading = true;
            this.pageLoaded = false;
            this.$http.get(this.api + '/manage/' + id, {}).then((res) => {
                this.setData(res.data);
                this.pageLoaded = !!this.data;
                this.state.loading = false;
            }).catch((error) => {
                console.log("PickUpReceipt:fetchData():error:", error);
            });
        },
        getNextName() {
            let packages = this.selectedPackages();
            let valid = true;
            let next = 0;
            do {
                valid = true;
                next++;
                packages.forEach(p => {
                    if (p.name === next.toString()) {
                        valid = false;
                    }
                });
            } while (!valid);
            return next.toString();
        },
        getUniqueId(items) {
            if (items && items.length > 0) {
                let ids = items.filter(item => 'id' in item).map(item => item.id);
                return Math.max(...ids) + 1;
            }
            return 0;
        },
        highlightRow(receipt) {
            this.selectedPickUpReceiptId = receipt.id;
        },
        selectedPackages() {
            let receipt = this.selectedPickUpReceipt();
            if (receipt) {
                return receipt.packages;
            }
            return [];
        },
        selectedPickUpReceipt() {
            if (this.selectedPickUpReceiptId !== null && this.data.pick_up_receipts && this.data.pick_up_receipts.length > 0) {
                let receiptIdx = this.selectedPickUpReceiptIdx();
                if (receiptIdx !== -1) {
                    return this.data.pick_up_receipts[receiptIdx];
                }
            }
            return null;
        },
        selectedPickUpReceiptIdx() {
            return this.data.pick_up_receipts.findIndex(r => r.id === this.selectedPickUpReceiptId);
        },
        selectView(option) {
            this.$router.push({name: option.routename, params: {id: this.data.id}});
        },
        setData(data) {
            let tmp = null;
            if (data.data) {
                tmp = data.data;
                if (tmp.pick_up_receipts) {
                    tmp.pick_up_receipts.forEach(receipt => {
                        receipt.cnt_packages = receipt.packages.length;
                        receipt.selected = false;
                    });
                } else {
                    tmp.pick_up_receipts = [];
                }
            }
            this.data = tmp;
            this.actions = data.actions;
            this.fields = data.fields;
            if (this.selectedPickUpReceiptId === null && this.data.pick_up_receipts && this.data.pick_up_receipts.length > 0) {
                this.selectedPickUpReceiptId = this.data.pick_up_receipts[0].id;
            }
            this.reloadTableComponent++;
        },
        updatePickUpReceipt(data) {
            this.recordDialogParameters.type = "update";
            this.recordDialogParameters.title = this.$i18n.tc("translations.Pick Up Receipt", 1);
            this.recordDialogParameters.api = this.api + '/update_receipt/' + this.data.id;
            this.recordDialogParameters.fields = this.fields.table;
            this.recordDialogParameters.data = data;
            this.recordDialogParameters.ok_label = null;
            this.recordDialogParameters.ok_event = 'ok';
            this.showRecordDialog = true;
        },
        updatePickUpReceipts() {
            let pickUpReceipts = [];
            this.data.pick_up_receipts.forEach(receipt => {
                let packages = [];
                receipt.packages.forEach(p => {
                    packages.push({
                        id: p.id,
                        name: p.name,
                        content: p.content,
                    });
                });
                pickUpReceipts.push({
                    id: receipt.id,
                    updated_at: receipt.updated_at ? receipt.updated_at : '',
                    updated_by: receipt.updated_by ? receipt.updated_by : '',
                    name: receipt.name,
                    packages: packages,
                });
            });

            this.$http.put(this.api + '/update/' + this.data.id, {pick_up_receipts: pickUpReceipts}, {}).then((res) => {
                this.setData(res.data);
                this.state.loading = false;
            }).catch((error) => {
                console.log("PickUpReceipt:updatePickUpReceipts():error:", error);
            });
        },
        updatePackage(packageIdx) {
            this.recordDialogParameters.type = "update";
            this.recordDialogParameters.title = this.$i18n.tc("translations.Package", 1);
            this.recordDialogParameters.api = this.api + '/update_package/' + this.data.id + '/' + this.selectedPickUpReceiptId;
            this.recordDialogParameters.fields = this.fields.packageFields;
            this.recordDialogParameters.data = this.selectedPackages()[packageIdx];
            this.showRecordDialog = true;
        },
    }
}
</script>

<style scoped>
</style>
